"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBar = void 0;
/* eslint-disable react/jsx-no-bind */
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const Search_1 = __importDefault(require("@material-ui/icons/Search"));
const HighlightOff_1 = __importDefault(require("@material-ui/icons/HighlightOff"));
const styles_1 = require("@material-ui/core/styles");
const useSearchBar_1 = require("../../hooks/useSearchBar");
// eslint-disable-next-line @rushstack/typedef-var
const useStyles = styles_1.makeStyles((theme) => styles_1.createStyles({
    button: {
        transitionProperty: 'none'
    }
}));
const SearchBar = (props) => {
    const classes = useStyles();
    const { placeholder = 'Search everything' } = props, others = __rest(props, ["placeholder"]);
    const { handleBlur, handleChange, handleEnterPress, handleFocus, handleResetClick, handleSubmitClick, value, isFocused, disabled } = useSearchBar_1.useSearchBar(others);
    return (react_1.default.createElement(core_1.TextField, { disabled: disabled, fullWidth: true, placeholder: placeholder, variant: "outlined", onFocus: handleFocus, onBlur: handleBlur, onChange: handleChange, onKeyPress: handleEnterPress, focused: isFocused, value: value, InputProps: {
            startAdornment: (react_1.default.createElement(core_1.InputAdornment, { position: "start" },
                react_1.default.createElement(Search_1.default, null))),
            endAdornment: (react_1.default.createElement(core_1.InputAdornment, { position: "end" },
                isFocused && (react_1.default.createElement(core_1.Button, { disabled: disabled, color: isFocused ? 'primary' : 'default', size: "small", variant: "contained", disableElevation: true, onClick: handleSubmitClick, classes: {
                        root: classes.button
                    } }, "Search")),
                !isFocused && props.activeQuery && (react_1.default.createElement(core_1.IconButton, { onClick: handleResetClick, "aria-label": "delete" },
                    react_1.default.createElement(HighlightOff_1.default, null)))))
        } }));
};
exports.SearchBar = SearchBar;
//# sourceMappingURL=index.js.map